// extracted by mini-css-extract-plugin
export default {"filter":"QuestionList_filter__mQYRB","fadeIn":"QuestionList_fadeIn__5SfPv","tblheader":"QuestionList_tblheader__rD84x","btn":"QuestionList_btn__Pah3v"};